<img 
    class="active" 
    [src]="src" 
    [alt]="_alt" 
    [ngClass]="_cssClasses" 
/>
